import { memo, useMemo, useState } from 'react'

import { IWebProps } from '../types'
import { useBlockingClickOutside } from '../hooks'
import { Flyout } from 'common-components'
import * as Styled from './styled'

const extraOffset = 20
const TtsWebFlyoutWrapper: React.FC<IWebProps> = (props: IWebProps) => {
  const {
    togglerElement,
    isOpen,
    width,
    height,
    content,
    onClose,
    ignoredClassNames,
    hasAlertTooltip
  } = props

  const [flyoutElement, setFlyoutElement] = useState<HTMLDivElement | null>(
    null
  )

  const ignoredRefs = useMemo(() => {
    return hasAlertTooltip ? [flyoutElement] : [flyoutElement, togglerElement]
  }, [flyoutElement, togglerElement, hasAlertTooltip])

  useBlockingClickOutside({
    refs: [...ignoredRefs],
    handler: onClose,
    ignoredClassNames,
    preventOutsideInteraction: hasAlertTooltip
  })
  const togglerCenterPosition = useMemo(() => {
    const { top, left, width, height } =
      togglerElement?.getBoundingClientRect() || {
        top: 0,
        left: 0,
        width: 0,
        height: 0
      }
    return {
      top: top + height / 2,
      left: left + width + extraOffset
    }
  }, [togglerElement])
  return (
    <Flyout
      isOpen={isOpen}
      anchorEl={togglerElement}
      onClose={onClose}
      options={{
        position: 'right',
        alignmentY: 'top',
        extraOffset
      }}
      ignoredSelectors={ignoredClassNames}
    >
      <Styled.TtsWebFlyoutWrapperContainer
        ref={setFlyoutElement}
        $togglerCenterPosition={togglerCenterPosition}
        $width={width}
        $height={height}
      >
        {content}
      </Styled.TtsWebFlyoutWrapperContainer>
    </Flyout>
  )
}

export default memo(TtsWebFlyoutWrapper)
